/* Application name */
export const APP_NAME = "Skicka impuls för kontrollutredning";
export const APP_SLUG = "impulskontrollutredning";

/* URL to fetch texts */
export const TEXT_URL =
    "/fk_apps/GenerelltREST/public/v2/wcmcontent/impulskontrollutredning";

/**
 * URL to navigate to when returning from the application, e.g. when aborting or
 * navigating from receipt.
 *
 * Examples:
 *
 * - Oinloggat: /wps/portal
 * - Inloggad:  /wps/myportal/privatpers/minasidor
 */
export const STARTPUNKT_URL = "/wps/portal";

export const kvittensSessionKey = "impulskontrollutredning.kvittens";

export const VISA_BARA_TEXTNYCKEL = "/visa_bara_textnyckel";
